import React from "react";
// import loader from '../../assets/images/loader/logo.png';
import loderlogoImg from "../../assets/images/logos/logo.png";
import "./loader.css";

const Loader = () => {
  return (
    <div className="loader-wapper">
      <div className="loader-box">
        <img src={loderlogoImg} alt="Loader" />
        <h6>Loading....</h6>
      </div>
    </div>
  );
};

export default Loader;
